import { render, staticRenderFns } from "./card-coupons.vue?vue&type=template&id=17f95f73&scoped=true&lang=pug&"
import script from "./card-coupons.vue?vue&type=script&lang=js&"
export * from "./card-coupons.vue?vue&type=script&lang=js&"
import style0 from "./card-coupons.vue?vue&type=style&index=0&id=17f95f73&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f95f73",
  null
  
)

export default component.exports